import combinedGACall from '../combinedGACall';

export default (action) =>
	combinedGACall({
		category: 'Get started Form',
		action,
	});
